/**
 * @generated SignedSource<<27c0f1c2d62801a915d87ea4ad2d7ecb>>
 * @relayHash dff8ff5a6bc16d18617c1eb39968b591
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9fc65e037108fa87b46934b790995fa4149f8f775642a49af132ab817106f34e

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubEditMode"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "operationType"
    },
    v4 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    },
    v5 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v6 = {
      "kind": "Variable",
      "name": "operationType",
      "variableName": "operationType"
    },
    v7 = [{
      "kind": "ScalarField",
      "name": "asapIssuer"
    }, {
      "kind": "ScalarField",
      "name": "mediaCollectionName"
    }, {
      "kind": "ScalarField",
      "name": "mediaToken"
    }, {
      "kind": "ScalarField",
      "name": "mediaUrl"
    }];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/],
      "kind": "Fragment",
      "name": "hubBootstrapWrapperQuery",
      "selections": [{
        "args": v5 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
        }]
      }, {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v0 /*: any*/, v2 /*: any*/, v1 /*: any*/, v4 /*: any*/, v3 /*: any*/],
      "kind": "Operation",
      "name": "hubBootstrapWrapperQuery",
      "selections": [{
        "args": v5 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": [{
            "kind": "Variable",
            "name": "ari",
            "variableName": "hubAri"
          }, v6 /*: any*/],
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v7 /*: any*/
        }, {
          "alias": "pageMediaConfig",
          "args": [{
            "kind": "Variable",
            "name": "ari",
            "variableName": "pageAri"
          }, v6 /*: any*/],
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v7 /*: any*/
        }, {
          "args": [{
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
          }],
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "__typename"
          }, {
            "kind": "InlineFragment",
            "selections": [{
              "concreteType": "HelpCenterBranding",
              "kind": "LinkedField",
              "name": "helpCenterBranding",
              "plural": false,
              "selections": [{
                "concreteType": "HelpCenterLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "fileId"
                }, {
                  "kind": "ScalarField",
                  "name": "url"
                }]
              }, {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "primary"
                }]
              }]
            }],
            "type": "HelpCenter"
          }, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }, {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [{
          "args": [{
            "items": [{
              "kind": "Variable",
              "name": "cloudIds.0",
              "variableName": "cloudId"
            }],
            "kind": "ListValue",
            "name": "cloudIds"
          }],
          "concreteType": "TenantContext",
          "kind": "LinkedField",
          "name": "tenantContexts",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "name": "cloudUrl"
          }]
        }]
      }]
    },
    "params": {
      "id": "9fc65e037108fa87b46934b790995fa4149f8f775642a49af132ab817106f34e",
      "metadata": {},
      "name": "hubBootstrapWrapperQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "fc48fc6598d48c617cc16e7581ac6b2b";
export default node;